<template>
  <div class="layout comm_details_warp" v-if="proMsg">
    <div v-wechat-title="$route.meta.title=proMsg.name"></div>
    <div class="comm_banner">
      <van-swipe class="my-swipe"  @change="swiperChange">
        <van-swipe-item v-if="proMsg.video">
          <videoPlayer 
          :url="proMsg.video.Link" 
          :cover="proMsg.video.Img" 
          :time="proMsg.video.Time"
          ref="videoPlays"
          ></videoPlayer>
        </van-swipe-item>
        <van-swipe-item v-for="(item, index) in proMsg.banner" :key="'banner-' + index">
          <img :src="item"
               preview="1"
               :preview-text="proMsg.Name"
               :large="item"
                
               v-load="'oProTopic'"
          />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="comm_info" v-if="proMsg">
      <div class="comm_title">
       <p>{{proMsg.name}}</p>
        <span v-if="proMsg.tag">{{proMsg.tag.Value}}</span>
      </div>
      <p class="comm_nh">{{proMsg.selling }}</p>
      <div class="area">
        <p>招商地区</p>
        <div class="area_wrap" v-if="proMsg.region">
          <div v-for="(item,index) in proMsg.region" :key="index+'r'">
            <span>{{item}}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 产品详情 -->
    <div class="comm_text" v-if="proMsg && proMsg.introduction">
      <span>产品详情</span>
      <div v-for="(item,index) in proMsg.introduction" :key="index">
        <!-- 文本 -->
        <p
                class="int-text"
                v-if="item.text"
                :style="{'font-size':item.text.fontSize,'color':item.text.color,'text-align':item.text.position}"
                v-html="$service.replaceSpeace(item.text.content)"
        ></p>
        <!-- 图片 -->
        <div
                class="int-img"
                v-if="item.picture && item.picture.type == 1"
                :style="{'padding-left':item.picture.padding+'px','padding-right':item.picture.padding+'px'}"
        >
          <div
                  v-for="(itm,idx) in item.picture.list"
                  :key="idx"
                  :style="{'margin-bottom':item.picture.spacing+'px'}"
          >
            <img
                    :src="itm.url"
                    preview="1"
                    :preview-text="proMsg.Name"
                    :large="itm.url"
                    v-load="'oProIntro'"
                    v-watermark="'oProView'"
                    style="width:100%;display: block" />
          </div>
        </div>
        <div
                class="comm_banner"
                style=""
                v-if="item.picture && item.picture.type == 2"
        >
          <van-swipe class="my-swipe" v-if="proMsg">
            <van-swipe-item v-for="(item, index) in item.picture.list" :key="'pic' + index">
              <img :src="item.url"  preview="1" :preview-text="proMsg.Name" :large="item.url"  style="width: 100%;height: 100%;display: block;" v-load="'oProIntro'" />
            </van-swipe-item>
          </van-swipe>
        </div>
        <!-- 视频 -->
        <div
                class="int-video"
                v-if="item.video && item.video.link"
                style="position:relative;"
        >
          <videoPlayer :url="item.video.link" :cover="proMsg.video.cover" :time="proMsg.video.time"></videoPlayer>
        </div>
      </div>
    </div>

    <!-- 公司信息 -->
    <div class="company_info" v-if="compMsg" @click="LinkCompany(proMsg.exhibitorId)">
      <img :src="compMsg.logo" v-if="compMsg.logo" v-load="'oLogo'"/>
      <img src="@assets/img/empty.png" v-else />
      <div class="comp_text">
        <p>{{compMsg.compName}}</p>
        <span v-if="compMsg.country && compMsg.country !='中国'">
          <i class="iconfont icon-dingwei1"></i>
          {{compMsg.country}}
        </span>
        <span v-else>
          <i class="iconfont icon-dingwei1"></i>
          {{compMsg.province}}
          <i v-if="compMsg.province && compMsg.city">·</i>
          {{compMsg.city}}
        </span>
      </div>
    </div>

    <!-- 其他产品 -->
    <div class="comm_more" v-if="otherPro.length" :class="otherPro.slice(0,3).length<3?'isNo3':''">
      <div
              class="more_item"
              v-for="(item,index) in otherPro.slice(0,3)"
              :key="index+'p'"
              @click="LinkProduct(item.id)"
      >
        <div class="img_div">
          <img :src="item.banner[0]" v-load="'oProMore'" v-if="item.banner[0]" />
          <img src="@assets/img/empty.png" v-else />
        </div>
        <p class="more_title">{{item.name}}</p>
        <p>{{item.selling}}</p>
      </div>

    </div>

    <div class="comm_footer">
      <div class="f_item" @click="LinkExhibitionDetails(proMsg.exhibitorId)">
        <i class="iconfont icon-chakanxiangqing"></i>
        <p>专题页</p>
      </div>
      <div class="f_item" :class="isFollower ? 'love' : ''" @click="addLove()">
        <i class="iconfont" :class="isFollower ? 'icon-love' : 'icon-guanzhu-xian'" ></i>
        <p>关注</p>
      </div>
      <div class="f_item" @click="share">
        <i class="iconfont icon-fenxiang2"></i>
        <p>分享</p>
      </div>
      <div class="f_btn">
        <van-button block @click="inquiry" color="linear-gradient(to right, #ffba00,  #ffa600)">询盘</van-button>
        <van-button block @click="LinkCompany(proMsg.exhibitorId)" color="linear-gradient(to right, #ff4e17, #f10100)">店铺</van-button>
      </div>
    </div>
    <!-- 询盘 -->
    <inquiry ref="inquiry"></inquiry>
    <!-- 分享 -->
    <liveShare ref="liveShare"></liveShare>
  </div>
</template>

<script>
  import inquiry from "@components/inquiry";
  import liveShare from "@/components/live-share/index";
  import videoPlayer from "../product-detail/videoPlayer";
  import { mapGetters, mapActions } from "vuex";
  export default {
    name: "comm_warp",
    components: {
      inquiry,
      videoPlayer,
      liveShare
    },
    data() {
      return {
        proMsg: null,
        otherPro: [],
        compMsg: null,
        isFollower: false,
      };
    },
    computed: {
      ...mapGetters({
        userId: "getUserId",
        exhibitionId: "getExhibitionId",
        userInfo: "getUserInfo"
      }),
      productId() {
        return this.$route.query.productId;
      }
    },
    watch: {
      $route: "init"
    },
    created() {
      this.init();
    },
    mounted: function() {
      //图片查看器打开后，打印本次查看器的实例（事件、方法、属性的示例）
      this.$preview.on("imageLoadComplete", (e, item) => {});
    },
    methods: {
      ...mapActions({
        getProduct: "company/getProduct",
        LinkCompany: "linkTo/LinkCompany",
        LinkProduct: "linkTo/LinkProduct2",
        LinkExhibitionDetails: "linkTo/LinkExhibitionDetails",
        addProView: "company/addProView",
        addProLove: "company/addProLove",
        addExhibitorFollower: "follower/addExhibitorFollower",
      }),
      async init() {
        let body = {
          id: this.productId,
          userId: this.userId || null
        };
        let allMsg = await this.getProduct(body);
        if (allMsg.detail.banner && allMsg.detail.banner.search(/^\[/) !== -1) {
          allMsg.detail.banner = JSON.parse(allMsg.detail.banner);
        } else {
          allMsg.detail.banner = [];
        }
        if (allMsg.detail.tag) {
          allMsg.detail.tag = JSON.parse(allMsg.detail.tag);
        }
        if (allMsg.detail.region && allMsg.detail.region.search(/^\[/) !== -1) {
          allMsg.detail.region = JSON.parse(allMsg.detail.region);
          let arr = [];
          console.log(allMsg.detail.region,'allMsg.detail.region')
          allMsg.detail.region.map(c => {
            if(c.length){
              if(c[c.length-1].value =="全部"){
                arr.push(c[c.length-2].value);
              }else{
                arr.push(c[c.length-1].value);
              }
            }
          });
          allMsg.detail.region = arr;
        }
        if (allMsg.detail.introduction.search(/^\[/) !== -1) {
          allMsg.detail.introduction = JSON.parse(allMsg.detail.introduction);
        }
        this.proMsg = allMsg.detail;
        if(this.proMsg.video && this.proMsg.video.indexOf("{") !== -1){
          this.proMsg.video = JSON.parse(this.proMsg.video)
        }
        this.$store.commit('company/setExhibitorId',this.proMsg.exhibitorId);
        this.$store.commit('company/setCompanyId',this.proMsg.compId);
        if (allMsg.proList.length) {
          allMsg.proList.map(c => {
            if (c.banner.search(/^\[/) !== -1) {
              c.banner = JSON.parse(c.banner);
            } else {
              c.banner = [];
            }
          });
        }
        this.otherPro = allMsg.proList;
        this.compMsg = allMsg.compInfo;
        this.isFollower = allMsg.isFollower;
        // document.title = this.proMsg.name;
        // console.log(this.proMsg, "this.proMsg");
        // console.log(this.compMsg,'this.compMsg')
        // console.log(this.otherPro,'this.otherPro')
        this.addProductViewer();
        this.$nextTick(()=>{
          this.getShareData();
        });
        this.checkForm();
      },
      checkForm(){
        let userInfo = {
            name: this.userInfo.nickName || this.userInfo.name,
            avatarUrl: this.userInfo.avatarUrl
          };
        if(this.$route.query.hotId){
          this.$store.commit('wxShare/setFromType',2);  // 判断是否来源于热榜
          let body = {
            popularzeId: this.$route.query.hotId,
            userId: this.userInfo.userId,
            userInfo: JSON.stringify(userInfo),
            fromType: 2,
          }
          this.$store.commit('wxShare/setFromData',body);
        } else {
          this.$store.commit('wxShare/setFromType',3);  // 产品的分享类型
          let body = {
            productId: this.productId,
            exhibitionId: this.exhibitionId,
            exhibitorId: this.proMsg.exhibitorId,
            userId: this.userInfo.userId,
            userInfo: JSON.stringify(userInfo),
            fromType: 0,
          }
          this.$store.commit('wxShare/setFromData',body);
        }
      },
      addProductViewer() {
        let userInfo = {
          nickName: this.userInfo.nickName,
          avatarUrl: this.userInfo.avatarUrl
        };
        let body = {
          productId: this.productId,
          exhibitionId: this.exhibitionId,
          exhibitorId: this.proMsg.exhibitorId,
          userId: this.userId,
          userInfo: JSON.stringify(userInfo)
        };
        this.addProView(body);

      },
      async addLove() {
        // 产品关注
        let userInfo = {
          nickName: this.userInfo.nickName,
          avatarUrl: this.userInfo.avatarUrl
        };
        let body = {
          productId: this.productId,
          exhibitionId: this.exhibitionId,
          exhibitorId: this.proMsg.exhibitorId,
          userId: this.userId,
          userInfo: JSON.stringify(userInfo)
        };
        let result = await this.addProLove(body);
        if (result.message == "已关注") {
          this.isFollower = true;
          this.$toast.success(result.message);
        } else {
          this.isFollower = false;
          this.$toast.success(result.message);
        }
      },
      getShareData(){
        let shareData={
          title:'推荐了展品 '+this.proMsg.name,
          desc:this.selling||'',
          imgUrl:this.proMsg.banner.length>0?this.proMsg.banner[0]:'',
        }
        this.$nextTick(()=>{
          this.$refs.liveShare.shareTo(shareData);
        })
      },
      swiperChange(){
        if(this.$refs.videoPlays)
        {
          //如果改变的时候视频正在播放，则暂停
          this.$refs["videoPlays"].Pause();
        }
      },
      // 人数超过w换算
      getCount(param) {
        let count = 0;
        if (param > 10000) {
          count = (param / 10000).toFixed(1);
          if (String(count)[count.length - 1] == 0) {
            count = (count / 1).toFixed(0);
          }
          return count + w;
        }
        return param;
      },
      //询盘点击
      inquiry() {
        this.$refs["inquiry"].open();
      },
      //点击店铺 跳转到店铺
      goToShop() {
        this.$router.push("/shop");
      },
      //分享点击
      share() {
        // console.log(this.proMsg,this.compMsg.compName,'proMsg');
        let opt = {
          title: "给您推荐一个优质产品",
          bannerTitle: this.proMsg.name,
          subhead:this.compMsg.compName,
          bannerUrl:this.proMsg.banner.length>0?this.proMsg.banner[0]:"http://img5.imgtn.bdimg.com/it/u=1567561585,1492480576&fm=26&gp=0.jpg",
        };
        this.$refs["liveShare"].open(opt);
      },
    },
    destroyed() {
      this.$store.commit('wxShare/setFromData',null);
      this.$store.commit('wxShare/setFromType',0); 
    },
  };
</script>

<style lang="scss" scoped>
  .padlr3 {
    padding: 0 0.3rem;
  }
  .comm_details_warp {
    background: #f5f5f5;
    .comm_banner {
      height: 7.5rem;
      border-bottom: 1px solid #f0f0f0;
      .video_box,
      .container,
      .player,
      .video-player {
        height: 100%;
      }
      .my-swipe {
        &::v-deep .van-swipe-item {
          color: #fff;
          font-size: 0.2rem;
          height: 7.5rem;
          text-align: center;
          background-color: #fff;
          .video-player {
            .video-js {
              height: 100%;
              .vjs-poster {
                background-size: cover;
              }
            }
          }
          img {
            width: 100%;
            height: 100%;
            display: block;
            // object-fit: cover;
          }
        }
      }
    }
    .comm_info{
      background: #fff;
      padding: 0.3rem 0.3rem 0.2rem;  
      margin-bottom: 0.2rem;
      > p {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .comm_title{
        color: #222;
        margin-bottom: 0.15rem;
        display: flex;
        align-items: center;
        p{
          font-size: 0.34rem;
          line-height: 0.5rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        span {
          flex-shrink: 0;
          display: inline-block;
          padding: 0 0.15rem;
          border: 1px solid #ff7a1f;
          font-size: 0.2rem;
          color: #ff7a1f;
          border-radius: 0.2rem;
          line-height: 0.4rem;
          height: 0.4rem;
          margin-left: 0.2rem;
        }
      }
      .comm_nh {
        padding-bottom: 0.22rem;
        line-height: 1.5;
      }
      .comm_tag {
        display: flex;
        flex-wrap: wrap;
        span {
          display: inline-block;
          padding: 0 0.2rem;
          min-width: 1.2rem;
          text-align: center;
          border: 1px solid transparent;
          height: 0.4rem;
          line-height: 0.4rem;
          border-radius: 2px;
          margin: 0 0.2rem 0.2rem 0;
          font-size: 0.26rem;
          &.orange {
            border-color: #ff7a1f;
            color: #ff7a1f;
          }
          &.bule {
            border-color: #1890ff;
            color: #1890ff;
          }
        }
      }
      .area {
        display: flex;
        color: #666;
        justify-content: space-between;
        p {
          line-height: 0.4rem;
          padding-right: 0.2rem;
          width: 1.4rem;
          white-space: nowrap;
        }
        .area_wrap{
          flex-grow: 1;
          display: flex;
          flex-wrap: wrap;
          div {
            margin: 0 0.2rem 0.2rem 0;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 0.4rem;
            padding: 0 0.1rem;
            min-width: 1.2rem;
            border-radius: 2px;
            background: #f5f5f5;
            span {
              font-size: 0.26rem;
            }
          }
        }

      }
    }
    .comm_text {
      background: #fff;
      color: #333;
      padding: 0.35rem 0;
      margin-bottom: 0.2rem;
      >span {
        line-height: 1;
        padding: 0 0 0.2rem 0.3rem;
        font-size: 0.32rem;
        display: inline-block;
        
      }
      p {
        line-height: 0.48rem;
        font-size: 0.28rem;
      }
      img{
        display: block;
      }
      .int-text{
        padding: 0.2rem 0.3rem;
      }
    }
    .company_info {
      display: flex;
      background: #fff;
      padding: 0.3rem;
      margin-bottom: 0.2rem;
      img {
        width: 1.2rem;
        height: 1.2rem;
        border: 1px solid #e6e6e6;
        border-radius: 0.06rem;
        margin-right: 0.2rem;
      }
      .comp_text {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        line-height: 1;
        padding: 0.2rem 0;
        p {
          font-size: 0.3rem;

          color: #333;
        }
        span {
          display: block;
          color: #666;
          .iconfont {
            vertical-align: text-bottom;
            // vertical-align: sub;
            font-size: 0.32rem;
          }
        }
      }
    }
    .comm_more {
      background: #fff;
      padding: 0.3rem;
      display: flex;
      justify-content: space-between;
      margin-bottom: 0.4rem;
      &.isNo3{
        &::after{
          content: '';
          width: 31.5%;
        }
      }
      .more_item {
        // width: 2.17rem;
        width: 31.5%;
        .img_div{
          position: relative;
          width: 100%;
          height: 0px;
          padding-top: 100%;
          >img{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            border-radius: 2px;
            height: 100%;
            // object-fit: cover;
          }
        }
        p {
          color: #333;
          font-size: 0.2rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          &.more_title {
            padding: 0.13rem 0 0.03rem;
            font-size: 0.24rem;
          }
        }
      }
    }

    .comm_footer {
      display: flex;
      height: 0.99rem;
      width: 100%;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      background: #fff;
      border-top: 1px solid #ebebeb;
      box-shadow: 0px -3px 10px rgba(235, 235, 235, 0.2);
      .f_item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        color: #808080;
        padding-top: 0.05rem;
        border-right: 1px solid #eee;
        width:1.09rem;
        &:first-child{
          color:#f85b0f;
        }
        .iconfont {
          font-size: 0.58rem;
        }
        p {
          font-size: 0.2rem;
          position: relative;
          top: -0.1rem;
        }
      }
      .f_btn {
        flex-grow: 1;
        display: flex;
        padding: 0.13rem 0.24rem;
        .van-button {
          height: 0.72rem;
          line-height: 0.72rem;
          width: 50%;
          &:first-child {
            border-radius: 0.04rem 0 0 0.04rem;
          }
          &:last-child {
            border-radius: 0 0.04rem 0.04rem 0;
          }
          span {
            font-size: 0.28rem;
          }
        }
      }
    }
  }
  .love {
    .iconfont,
    p {
      color: #f85b0f;
    }
  }
</style>
